import { SearchFields, SortFields } from '../types/account';

export const ROLE: Array<{ id: string; name: string }> = [
  { id: 'staff', name: 'Staff' },
  { id: 'technician', name: 'Technicians' },
];

export const ROLES = {
  superAdmin: 'super_admin',
  admin: 'admin',
  staff: 'staff',
  technician: 'technician',
};

export const DEPARTMENT: Array<{ id: string; name: string }> = [
  { id: 'contents', name: 'Contents' },
  { id: 'emergency', name: 'Emergency' },
  { id: 'marketing', name: 'Marketing' },
  { id: 'reconstruction', name: 'Reconstruction' },
  { id: 'roofing_exterior', name: 'Roofing/Exterior ' },
];

export const SEARCH_FIELDS: SearchFields = ['staff', 'technician', 'department', 'address'];

export const SORT_FIELDS: SortFields = ['name', 'department', 'phone', 'address'];
